<template>
    <div>
        <!--edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header">
                    <h3 class="fw-bold mb-3">Chamandos em Andamento</h3>
                    <ul class="breadcrumbs mb-3">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Chamandos em Andamento</a>
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <v-tabs v-model="tab" color="deep-purple-accent-4" bg-color="#dadcdf">
                                    <v-tab value="dados" class="tabinfo"
                                        style="font-size: 13px;text-transform: none !important;">Detalhes do
                                        Chamados</v-tab>
                                </v-tabs>
                                <v-window v-model="tab">
                                    <!--dados-->
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4">
                                                        <v-card color="#f7f7f7" style="padding: 15px;">
                                                            <div class="row">
                                                                <div class="col-md-3 col-lg-3">
                                                                    <div class="d-flex" style="padding-bottom: 5px;">
                                                                        <label
                                                                            style="padding-right: 3px;font-weight: 600;">Id:</label>
                                                                        <span>{{ Chamado.sccId }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-9 col-lg-9">
                                                                    <div class="d-flex" style="padding-bottom: 5px;">
                                                                        <label
                                                                            style="padding-right: 3px;font-weight: 600;">Data:</label>
                                                                        <span>{{ formattedDate(Chamado.sccDataCriacao)
                                                                            }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-12 col-lg-12">
                                                                    <div class="d-flex" style="padding-bottom: 5px;">
                                                                        <label
                                                                            style="padding-right: 3px;font-weight: 600;">Urgência:</label>
                                                                        <span>{{ListUrgencias.filter(x => x.Id ==
                                                                            Chamado.sccUrgencia)[0].Nome}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-12 col-lg-12">
                                                                    <div class="d-flex" style="padding-bottom: 5px;">
                                                                        <label
                                                                            style="padding-right: 3px;font-weight: 600;">Solicitante:</label>
                                                                        <span>{{ Chamado.sccNomeSolicitante }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-12 col-lg-12">
                                                                    <div class="d-flex" style="padding-bottom: 5px;">
                                                                        <label
                                                                            style="padding-right: 3px;font-weight: 600;">E-mail:</label>
                                                                        <span>{{ Chamado.sccEmailSolicitante }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-12 col-lg-12">
                                                                    <div class="d-flex" style="padding-bottom: 5px;">
                                                                        <label
                                                                            style="padding-right: 3px;font-weight: 600;">Contato:</label>
                                                                        <span>{{ Chamado.sccTelefoneSolicitante
                                                                            }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-12 col-lg-12">
                                                                    <div class="d-flex" style="padding-bottom: 5px;">
                                                                        <label
                                                                            style="padding-right: 3px;font-weight: 600;">Ocorrido:</label>
                                                                        <span>{{ formattedDate(Chamado.sccDataOcorrido)
                                                                            }}</span>
                                                                    </div>
                                                                </div>
                                                                <hr>
                                                                <div class="col-md-12 col-lg-12">
                                                                    <div class="d-flex"
                                                                        style="padding-bottom: 10px;padding-top: 5px;">
                                                                        <label
                                                                            style="padding-right: 3px;font-weight: 600;">Título:</label>
                                                                        <span>{{ Chamado.sccTituloChamado }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-12 col-lg-12">
                                                                    <div class="" style="padding-bottom: 5px;">
                                                                        <label
                                                                            style="padding-right: 3px;font-weight: 600;">Texto
                                                                            Chamado</label>
                                                                        <p v-html="Chamado.sccTextoChamado"></p>
                                                                    </div>
                                                                </div>
                                                                <hr>
                                                                <div class="col-md-12 col-lg-12">
                                                                    <div class="" style="padding-bottom: 5px;">
                                                                        <label
                                                                            style="padding-right: 3px;font-weight: 600;padding-bottom: 10px;">Anexos</label>
                                                                        <div v-for="doc in ListaDocChamadoPai"
                                                                            :key="doc.sdcId"
                                                                            style="margin-bottom: 20px;">
                                                                            <a @click="openInNewTab(doc.sdcUrlDocumento)"
                                                                                style="color:#333333;font-size: 12px;cursor: pointer;">
                                                                                <v-icon
                                                                                    class="editiconcor">mdi-file</v-icon>
                                                                                {{ doc.sdcUrlDocumento }}
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </v-card>
                                                         <v-card color="#f7f7f7" style="padding: 15px;margin-top: 20px;"
                                                            v-if="ListStatusChamadosStcId != '' && Chamado!=''">
                                                            <v-row>
                                                                <v-col cols="12" md="12">
                                                                    <div>
                                                                        <label>Etapa Atual</label>
                                                                        <h3>{{ ListStatusChamadosStcId.filter(x=> x.sscId == Chamado.sscId)[0].sscNomeEtapa }}</h3>
                                                                    </div>
                                                                </v-col>
                                                                <v-col cols="12" md="12" style="text-align: center;" 
                                                                  v-if="ListStatusChamados.filter(x=> x.stcId == Chamado.stcId)[ListStatusChamados.filter(x=> x.stcId == Chamado.stcId).length-1].sscId != Chamado.sscId">
                                                                    <div class="card-action">
                                                                      <button type="button" class="btn btn-success" style="color:#ffffff;" @click="FinalizarChamado()">
                                                                            Fechar Chamado
                                                                        </button>
                                                                    </div>
                                                                </v-col>
                                                            </v-row>
                                                         </v-card>
                                                    </div>
                                                    <div class="col-md-8 col-lg-8">
                                                        <v-card color="#f7f7f7" style="padding: 15px;" v-if="TipoPessoas!=''">
                                                            <div class="row">
                                                                <h4>Respostas do Chamado</h4>
                                                                <div class="col-md-12 col-lg-12" style="padding-top: 30px;">
                                                                    <div class="col-md-12 col-lg-12"  v-for="resp in ListaFluxoChamado" :key="resp.sfcId">
                                                                        <div class="row">
                                                                            <div class="col-md-4 col-lg-4">
                                                                                <div class="d-flex"
                                                                                    style="padding-bottom: 5px;">
                                                                                    <label
                                                                                        style="padding-right: 3px;font-weight: 600;">Data:</label>
                                                                                    <span>{{
                                                                                        formattedDate(resp.sfcDataCriacao)
                                                                                        }}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-5 col-lg-5">
                                                                                <div class="d-flex"
                                                                                    style="padding-bottom: 5px;">
                                                                                    <label
                                                                                        style="padding-right: 3px;font-weight: 600;">Usuário:</label>
                                                                                    <span>{{ resp.sccTituloChamado
                                                                                        }}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-3 col-lg-3">
                                                                                <div class="d-flex"
                                                                                    style="padding-bottom: 5px;">
                                                                                    <label
                                                                                        style="padding-right: 3px;font-weight: 600;">Tipo:</label>
                                                                                    <span>{{ resp.tpeId == 0? "GarantePay" : TipoPessoas.filter(x=> x.tpeId == resp.tpeId)[0].tpeNome }}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-12 col-lg-12">
                                                                                <div class=""
                                                                                    style="padding-bottom: 5px;">
                                                                                    <label
                                                                                        style="padding-right: 3px;font-weight: 600;">Texto:</label>
                                                                                    <p v-html="resp.sccTextoChamado">
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-12 col-lg-12" v-if="ListaDocumentosChamado.filter(x => x.sccId == resp.sccId && x.sfcId == resp.sfcId).length > 0">
                                                                            <div class="" style="padding-bottom: 5px;">
                                                                                <label style="padding-right: 3px;font-weight: 600;padding-bottom: 10px;">Anexos</label>
                                                                                <div v-for="docresp in ListaDocumentosChamado.filter(x => x.sccId == resp.sccId && x.sfcId == resp.sfcId)"
                                                                                    :key="docresp.sdcId"
                                                                                    style="margin-bottom: 20px;display: inline-flex;">
                                                                                    <a :href="$imgURL + docresp.sdcUrlDocumento"
                                                                                        target="_blank"
                                                                                        style="color:#333333;font-size: 15px;"
                                                                                        :title="docresp.sdcUrlDocumento">
                                                                                        <v-icon
                                                                                            class="editiconcor">mdi-file</v-icon>
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                       <hr>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </v-card>

                                                        <v-card color="#ffffff" style="padding: 15px;" 
                                                        v-if="(User.tpeid == 0 ? null : User.tpeid) === (ListStatusChamados.filter(x=> x.sscId == Chamado.sscId)[0].tpeId == 5 ? (Chamado.tpeId == 0 ? null : Chamado.tpeId) : ListStatusChamados.filter(x=> x.sscId == Chamado.sscId)[0].tpeId)
                                                              && (ListStatusChamados.filter(x=> x.stcId == Chamado.stcId)[ListStatusChamados.filter(x=> x.stcId == Chamado.stcId).length-1].sscId != Chamado.sscId)">
                                                            <div class="row">
                                                                <div class="col-md-12 col-lg-12">
                                                                    <label
                                                                        style="padding-right: 3px;font-weight: 600;">Adicionar
                                                                        comentário ao Chamado</label>
                                                                    <div class="col-md-12 col-lg-12">
                                                                        <div class="form-group">
                                                                            <ckeditor :editor="editor" @ready="onReady"
                                                                                v-model="TextoRespostaChamado"
                                                                                :config="$ckconfig"></ckeditor>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-5 col-lg-5">
                                                                    <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou PDF</label>
                                                                    <v-file-input v-model="selectedFile"
                                                                        label="Selecione o arquivo" variant="underlined"
                                                                        prepend-icon="mdi-file"
                                                                        accept="image/*,application/pdf"></v-file-input>
                                                                </div>
                                                                <div class="col-md-3 col-lg-3">
                                                                    <button type="button" class="btn btn-info"
                                                                        @click.prevent="InserirDocumento()"
                                                                        style="color:#ffffff;margin-top: 20px;">
                                                                        Anexar
                                                                    </button>
                                                                </div>
                                                                <div class="col-md-4 col-lg-4 d-flex">
                                                                    <div v-for="(doc2, index) in ListaDocumentosResposta"
                                                                        :key="index" style="margin-bottom: 20px;">
                                                                        <a :href="$imgURL + doc2.UrlArquivo"
                                                                            target="_blank"
                                                                            style="color:#333333;font-size: 20px;"
                                                                            :title="doc2.UrlArquivo">
                                                                            <v-icon
                                                                                class="editiconcor">mdi-file</v-icon>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-12 col-lg-12"
                                                                    style="padding-top: 20px; text-align: right;">
                                                                    <a href="#" @click="EditCancel()"
                                                                        class="btn btn-link">Cancelar</a>
                                                                    <button type="button" class="btn btn-success"
                                                                        style="color:#ffffff;" @click="Add()">
                                                                        Salvar Resposta
                                                                    </button>

                                                                </div>
                                                            </div>
                                                        </v-card>


                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--dados-->
                                </v-window>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Chamandos em Andamento</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body" v-if="ListUrgencias != '' && ListStatusChamados != ''">
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <easy-data-table :headers="headers" :items="ListaChamados" v-model="itemsSelected"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                                    <template #item-sccUrgencia="item">
                                        <span>{{ListUrgencias.filter(x => x.Id == item.sccUrgencia)[0].Nome}}</span>
                                    </template>
                                    <template #item-sccDataCriacao="item">
                                        <span>{{ formattedDate(item.sccDataCriacao) }}</span>
                                    </template>
                                    <template #item-sscId="item">
                                        <span>{{ListStatusChamados.filter(x => x.sscId == item.sscId)[0].sscNomeEtapa
                                            }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                            <v-icon class="editiconcor">mdi-file-edit</v-icon>
                                            <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                                        </v-btn>
                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {
    name: 'ChamadosAndamentoView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
        EditView: false,
        tab: null,
        editor: DecoupledEditor,
         User: {
            garid:0,
            tpeid:0,
            pesid:0,
            cusid:0,
            tusid:0
        },
        ListaChamados: [],
        headers: [
            { text: "Id", value: "sccId", sortable: true, },
            { text: "Data", value: "sccDataCriacao", sortable: true, },
            { text: "Urgência", value: "sccUrgencia", sortable: true, },
            { text: "Status", value: "sscId", sortable: true, },
            { text: "Solicitante", value: "sccNomeSolicitante", sortable: true, },
            { text: "Telefone", value: "sccTelefoneSolicitante", sortable: true, },
            { text: "E-mail", value: "sccEmailSolicitante", sortable: true, },
            { text: "Título", value: "sccTituloChamado", sortable: true, },

            { text: 'Ações', value: 'actions' }
        ],
        ListUrgencias: [
            { Id: 1, Nome: 'Baixa' }, { Id: 2, Nome: 'Média' }, { Id: 3, Nome: 'Alta' }
        ],
        ListStatusChamados: [],
        ListStatusChamadosStcId: [],
        TipoUsuario: [],
        TipoPessoas: [],
        TipoUsuarioGeral: [],
        PerfilUsuarios: [],

        // dados
        TiposChamados: {
            stcId: 0,
            stcNomeTipoChamado: '',
            stcVisivelGarantePay: false,
            stcVisivelGarantidora: false,
            stcVisivelImobiliaria: false,
            stcVisivelParceiro: false,
            stcVisivelCliente: false,
        },
        ListTiposChamados: [],
        StatusChamado: {
            sscId: 0,
            stcId: 0,
            sscNomeEtapa: '',
            tpeId: null,
            tusId: null,
            sscOrdem: 0,
        },
        Chamado: [],
        ListaDocumentosChamado: [],
        ListaDocChamadoPai: [],
        TextoRespostaChamado: '',
        ListaFluxoChamado: [],
        // dados      
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
        selectedFile: '',
        ListaDocumentosResposta: [],
        Usuarios: [],
        Usuario: [],
    }),
    methods: {
        startLoading() {
            this.isLoading = true;
        },
        stopLoading() {
            this.isLoading = false;
        },
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY HH:mm:ss')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/ChamadosAndamento/upload`, formData);
            return uploadResult;
        },
         buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/ChamadosAndamento/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        async InserirDocumento() {
            if (this.selectedFile != '' && this.selectedFile != null) {
                const uploadSuccess = await this.UploadImg(this.selectedFile[0]);
                this.ListaDocumentosResposta.push({ UrlArquivo: uploadSuccess.data.nameFile });
                this.selectedFile = '';
            }
            else {
                this.$mensagemAviso("Selecione o Documento a ser enviado.");
            }
        },
        //edit
        EditNew() {
           this.$router.push("/CadastroChamados");
        },
        EditCancel() {
            this.$router.go(0);
        },
        async EditGrid(item) {
            //console.log('aqui')
            //console.log(item)
            this.EditView = true;
            this.tab = 'dados';
            this.Chamado = this.ListaChamados.filter(x => x.sccId == item.sccId)[0];
            this.ListStatusChamadosStcId = this.ListStatusChamados.filter(x=> x.stcId ==  this.Chamado.stcId);
            //console.log('this.ListStatusChamadosStcId')
            //console.log(this.ListStatusChamadosStcId)
            //console.log(this.Chamado);
            
            await axios.get(`/Telas/ChamadosAndamento/GetAllBySccIdDocumentosChamados/` + item.sccId)
                .then(response => {
                    this.ListaDocumentosChamado = response.data;
                    this.ListaDocChamadoPai = this.ListaDocumentosChamado.filter(x => x.sfcId == null)
                });

            await axios.get(`/Telas/ChamadosAndamento/GetAllBySccIdFluxoChamados/` + item.sccId)
                .then(response => {
                    this.ListaFluxoChamado = response.data;
                });
        },
        Add() {
            if (this.TextoRespostaChamado == '' || this.TextoRespostaChamado == null) {
                this.$mensagemAviso("Adicione um comentário ao Chamado.")
            }
            else {
                let _resposta = {
                    sfcDataCriacao: moment().format('YYYY-MM-DDTHH:mm:ss'),
                    sccTitulochamado: this.User.nome,
                    sccTextoChamado: this.TextoRespostaChamado,
                    tpeId: this.User.tpeid,
                    cusId: this.User.cusid,
                    pesPesId: this.User.pesid,
                    sccId: this.Chamado.sccId
                }
                axios.post(`/Telas/ChamadosAndamento/AddFluxoChamados`, _resposta)
                    .then(response => {
                        if (response.data > 0) {
                            if (this.ListaDocumentosResposta.length > 0){
                                    this.ListaDocumentosResposta.forEach(element => {
                                        let _docresposta = {
                                            sdcId: 0,
                                            sdcDataCriacao: moment().format('YYYY-MM-DDTHH:mm:ss'),
                                            sdcUrlDocumento: element.UrlArquivo,
                                            sccId: this.Chamado.sccId,
                                            sfcId: response.data
                                        }

                                        axios.post(`/Telas/ChamadosAndamento/AddDocumentosChamados`, _docresposta)
                                            .then(response2 => {
                                                if (response2.data > 0) {
                                                    _docresposta.sdcId = response2.data;
                                                    this.UpdateStatuschamado();
                                                    this.TextoRespostaChamado = '';
                                                    this.ListaDocumentosResposta = [];
                                                }
                                            });
                                    });
                            }
                            else{
                                this.UpdateStatuschamado();
                                this.TextoRespostaChamado = '';
                                this.ListaDocumentosResposta = [];
                            }
                        }
                    });
            }
        },
        UpdateStatuschamado() {
          let _chamadoStatus = this.ListStatusChamadosStcId.filter(x=> x.sscId == this.Chamado.sscId)
          let _newStatusChamado = this.ListStatusChamadosStcId.filter(x=> x.sscId == _chamadoStatus[0].sscOrdem)
          this.Chamado.sscId = _newStatusChamado[0].sscId;

            axios.put(`/Telas/ChamadosAndamento/UpdateControleChamado`, this.Chamado)
                .then(response => {
                    if (response.status == 200) {
                        this.ValidaRegraEnvio(_newStatusChamado);
                        this.$mensagemAvisoSucesso("Chamado Alterado.")
                        this.Get();
                    }
                });
        },
        FinalizarChamado() {
            this.$mensagemConfirma('Confirma finalização Chamado?')
                .then((result) => {
                    if (result.isConfirmed) {
                       this.Chamado.sscId = this.ListStatusChamadosStcId[this.ListStatusChamadosStcId.length - 1].sscId;
                        axios.put(`/Telas/ChamadosAndamento/UpdateControleChamado`, this.Chamado)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Chamado Finalizado.")
                                    this.Get();
                                }
                            });
                    }
                });
        },
        async ValidaRegraEnvio(newStatusChamado) {
            try {
                // Busca em paralelo os tipos de pessoas e os usuários
                const [tpResp, usrResp] = await Promise.all([
                    axios.get(`/Telas/ChamadosAndamento/GetAllTipoPessoas`),
                    axios.get(`/Telas/ChamadosAndamento/GetAllCadastroUsuarios`),
                ]);

                this.TipoPessoas = tpResp.data;
                this.Usuarios = usrResp.data;

                // Filtra a lista de destinatários com base em tpeId e tusId de StatusChamados[0]
                const filtroStatus = newStatusChamado[0];
                let destinatarioemailList = [];
                if (filtroStatus.tpeId == 5){
                     destinatarioemailList = [ this.Chamado.sccEmailSolicitante ];
                }
                else{
                    destinatarioemailList = this.Usuarios
                    .filter(
                        (u) => u.tpeId === filtroStatus.tpeId && u.admTipoUsuario.tusId === filtroStatus.tusId
                    )
                    .map((u) => u.cusEmail); 
                }   
                //console.log("destinatarioemailList final:", destinatarioemailList);        

                if (!destinatarioemailList.length) {
                    console.warn("Nenhum destinatário encontrado para envio de e-mail.");
                    return;
                }

                // Monta dados para passar ao envio de e-mail
                const _nomede = this.Chamado.sccNomeSolicitante;
                const tipoChamado = this.ListTiposChamados.find(
                    (x) => x.stcId === newStatusChamado[0].stcId
                );
                const _assuntotexto = `${tipoChamado.stcNomeTipoChamado} - Cod:  ${this.Chamado.sccId} - ${newStatusChamado[0].sscNomeEtapa}`;
                const _codChamado = this.Chamado.sccId;
                const _newstatus = newStatusChamado[0].sscNomeEtapa;

                // Define nomePara conforme tpeId
                let _nomepara = "";
                switch (filtroStatus.tpeId) {
                    case 1:
                        _nomepara = "Garantidora";
                        break;
                    case 2:
                        _nomepara = "Parceiro";
                        break;
                    case 3:
                        _nomepara = "Imobiliária";
                        break;
                    case 4:
                        _nomepara = "Cliente";
                        break;
                    case 5:
                        _nomepara = this.Chamado.sccNomeSolicitante;
                        break;
                    default:
                        _nomepara = "GarantePay";
                }

                // Aguarda o envio de e-mail para todos os destinatários
                await this.EnviaAvisoStatusChamado(
                    _nomede,
                    _nomepara,
                    _assuntotexto,
                    destinatarioemailList,
                    _codChamado,
                    _newstatus
                );
            } catch (err) {
                console.error("Erro em ValidaRegraEnvio:", err);
                // Se der erro aqui, o fluxo de CadastrarChamado vai continuar após o catch
            }
        },

        async EnviaAvisoStatusChamado(
            nomede,
            nomepara,
            assuntotexto,
            destinatarioemailList,
            codChamado,
            newstatus
        ) {
            try {
                // Busca todos os templates e filtra o de mpdId = 19
                const tmplResp = await axios.get(`/Telas/ChamadosAndamento/GetByIdMensagemPadrao/18`);
                this.templateEmail = tmplResp.data;
                const textoBase = this.templateEmail.mpdTexto;

               // console.log('destinatarioemailList')
               // console.log(destinatarioemailList)
                // Para cada destinatário, monta o objeto e chama o POST de envio
                const promessasDeEnvio = destinatarioemailList.map((dest) => {
                    const _dadosEmail = {
                        nomeDe: nomede,
                        nomePara: nomepara,
                        assunto: assuntotexto,
                        destinatario: dest,
                        emailResposta: this.$GarantePayEmail,
                        textoEmail: textoBase
                            .replace("[CodChamado]", codChamado)
                            .replace("[NovoStatus]", newstatus)
                            .replace('[Logo]', '<center><img src="https://garantepay.net.br/images/logogarantepay.jpg" style="width: 200px;" /></center>'),
                            listAnexos: null
                    };

                    return axios
                        .post(`/Telas/ChamadosAndamento/Enviamail`, _dadosEmail)
                        .then((res) => {
                            if (res.data == 1) {
                                console.log(`E-mail enviado para ${dest}`);
                            } else {
                                console.warn(`Falha ao enviar para ${dest}: resposta =`, res.data);
                            }
                        })
                        .catch((err) => {
                            console.error(`Erro no envio para ${dest}:`, err);
                        });
                });

                // Aguarda todas as requisições de e-mail (OK ou falha)
                await Promise.all(promessasDeEnvio);
            } catch (err) {
                console.error("Erro em EnviaAvisoStatusChamado:", err);
            }
        },
        //edit
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        const param1 = item.stcId;
                        axios.delete(`/Telas/ChamadosAndamento/DeleteTiposChamados/${param1}`)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.Get();
                                }
                            });
                    }
                });
        },
        //status
        CarregaStatus(_stcId) {
            axios.get(`/Telas/ChamadosAndamento/GetAllByStcIdStatusChamados/` + _stcId)
                .then(response => {
                    this.ListStatusChamados = response.data;
                });
        },
        async AddStatus() {
            if (this.StatusChamado.sscNomeEtapa == null || this.StatusChamado.sscNomeEtapa === '') {
                this.$mensagemAviso("Nome Etapa obrigatório.");
            }
            else if ((this.StatusChamado.tusId == null || this.StatusChamado.tusId === '') && this.StatusChamado.tpeId != 4 && this.StatusChamado.tpeId != 5) {
                this.$mensagemAviso("Tipo Perfil obrigatório.");
            }
            else if (this.StatusChamado.sscOrdem == null || this.StatusChamado.sscOrdem === '') {
                this.$mensagemAviso("Ordem obrigatório.");
            }
            else {
                // Continuação do processamento
                this.StatusChamado.stcId = this.TiposChamados.stcId;
                if (this.StatusChamado.tpeId != '' && this.StatusChamado.tpeId != null) {
                    this.StatusChamado.tpeId = parseInt(this.StatusChamado.tpeId, 10);
                }
                this.StatusChamado.sscOrdem = parseInt(this.StatusChamado.sscOrdem, 10);
                if (this.StatusChamado.tpeId != 4 && this.StatusChamado.tpeId != 5) {
                    this.StatusChamado.tusId = parseInt(this.StatusChamado.tusId, 10);
                }

                await axios.post(`/Telas/ChamadosAndamento/AddStatusChamados`, this.StatusChamado)
                    .then(response => {
                        if (response.data > 0) {
                            this.StatusChamado.sscId = response.data;
                            this.$mensagemAvisoSucesso("Status Incluído")
                            this.StatusChamado.sscId = 0;
                            this.StatusChamado.sscNomeEtapa = '';
                            this.StatusChamado.tpeId = null;
                            this.StatusChamado.tusId = null;
                            this.StatusChamado.sscOrdem = 0;

                            axios.get(`/Telas/ChamadosAndamento/GetAllStatusChamado`)
                                .then(response => {
                                    this.ListStatusChamados = response.data;
                                });
                        }
                    });
            }
        },
        EditarStatus(value) {
            this.StatusChamado = value;
        },
        PutStatus() {

            if (this.StatusChamado.sscNomeEtapa == null || this.StatusChamado.sscNomeEtapa === '') {
                this.$mensagemAviso("Nome Etapa obrigatório.");
            }
            else if ((this.StatusChamado.tusId == null || this.StatusChamado.tusId === '') && this.StatusChamado.tpeId != 4 && this.StatusChamado.tpeId != 5) {
                this.$mensagemAviso("Tipo Perfil obrigatório.");
            }
            else if (this.StatusChamado.sscOrdem == null || this.StatusChamado.sscOrdem === '') {
                this.$mensagemAviso("Ordem obrigatório.");
            }
            else {
                this.StatusChamado.stcId = this.TiposChamados.stcId;
                if (this.StatusChamado.tpeId != '' && this.StatusChamado.tpeId != null) {
                    this.StatusChamado.tpeId = parseInt(this.StatusChamado.tpeId, 10);
                }
                this.StatusChamado.sscOrdem = parseInt(this.StatusChamado.sscOrdem, 10);
                if (this.StatusChamado.tpeId != 4 && this.StatusChamado.tpeId != 5) {
                    this.StatusChamado.tusId = parseInt(this.StatusChamado.tusId, 10);
                }


                axios.put(`/Telas/ChamadosAndamento/UpdateStatusChamados`, this.StatusChamado)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.StatusChamado.sscId = 0;
                            this.StatusChamado.sscNomeEtapa = '';
                            this.StatusChamado.tpeId = null;
                            this.StatusChamado.tusId = null;
                            this.StatusChamado.sscOrdem = 0;


                            axios.get(`/Telas/ChamadosAndamento/GetAllStatusChamado`)
                                .then(response => {
                                    this.ListStatusChamados = response.data;
                                });
                        }
                    });
            }

        },
        DeleteStatus(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        const param1 = item.sscId;
                        axios.delete(`/Telas/ChamadosAndamento/DeleteStatusChamados/${param1}`)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.StatusChamado.sscId = 0;
                                    this.StatusChamado.sscNomeEtapa = '';
                                    this.StatusChamado.tpeId = null;
                                    this.StatusChamado.tusId = null;
                                    this.StatusChamado.sscOrdem = 0;

                                    axios.get(`/Telas/ChamadosAndamento/GetAllStatusChamado`)
                                        .then(response => {
                                            this.ListStatusChamados = response.data;
                                        });
                                }
                            });
                    }
                });
        },
        EditStatusCancel() {
            this.StatusChamado.sscId = 0;
            this.StatusChamado.sscNomeEtapa = '';
            this.StatusChamado.tpeId = null;
            this.StatusChamado.tusId = null;
            this.StatusChamado.sscOrdem = 0;

            axios.get(`/Telas/ChamadosAndamento/GetAllStatusChamado`)
                .then(response => {
                    this.ListStatusChamados = response.data;
                });
        },
        //status
        TipoPessoaSelected() {
            this.StatusChamado.tusId = null;
            if (this.StatusChamado.tpeId != 4 && this.StatusChamado.tpeId != 5) {
                this.TipoUsuario = this.TipoUsuarioGeral.filter(x => x.tpeId === this.StatusChamado.tpeId);
            }
        },
        async Get() {
             this.EditView = false;
         await axios.get(`/Telas/ChamadosAndamento/GetDados`)
               .then(response => {
                 this.TipoPessoas = response.data.tipoPessoas;
                 this.TipoPessoas.push({tpeId: 4, tpeNome: "Cliente",tpeVisivel: true,tpeAtivo: true});
                 this.TipoPessoas.push({tpeId: 5, tpeNome: "Quem Abriu Chamado",tpeVisivel: true,tpeAtivo: true});
                 this.ListTiposChamados = response.data.suptiposChamados;
                 this.ListStatusChamados = response.data.supStatusChamados;
                 this.User.garid = response.data.garId;
                 this.User.tpeid = response.data.tpeId;
                 this.User.pesid = response.data.pesId;
                 this.User.cusid = response.data.cusId;
                 this.User.tusid = response.data.tusId;

                 this.ListaChamados = response.data.supControleChamados;
                        console.log('this.ListaChamados', this.ListaChamados);

                        let ListaFinalChamados = [];

                        this.ListaChamados.forEach(element => {
                        // Encontra o status correspondente ao chamado
                        const _statusChamado = this.ListStatusChamados.find(
                            x => x.sscId === element.sscId
                        );
                        // console.log('_statusChamado')
                        // console.log(_statusChamado)
                        // Se o elemento pertencer ao usuário logado OU se o status permitir que o usuário veja
                        if (
                            element.tpeId === this.User.tpeid &&
                            element.pesPesId === this.User.pesid
                        ) {
                            ListaFinalChamados.push(element);
                        } else if (
                            _statusChamado &&
                            (this.User.tpeid == 0 ? null : this.User.tpeid) === _statusChamado.tpeId &&
                            this.User.tusid === _statusChamado.tusId
                        ) {
                            ListaFinalChamados.push(element);
                        }
                        });

                        // console.log('ListaFinalChamados', ListaFinalChamados);
                        //  console.log(this.ListStatusChamados)
                        // console.log(this.ListStatusChamados.filter(y=> y.stcId == 1).length-1)
                        // console.log(this.ListStatusChamados.filter(w=> w.stcId == 1)[this.ListStatusChamados.filter(y=> y.stcId == 1).length-1].sscId)
                         

                        // Substitui ListaChamados pelo array filtrado
                        this.ListaChamados = ListaFinalChamados.filter(x=> x.sscId != this.ListStatusChamados.filter(w=> w.stcId == x.stcId)[this.ListStatusChamados.filter(y=> y.stcId == x.stcId).length-1].sscId);
                        //console.log('ListaFinalChamados2', this.ListaChamados);
           });  
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
